import { ACTION_TYPE, ActionInfo, ActionPersistData, ElementToUpdate } from "../action.model";
/**
 * Maps {ActionInfo} to {ActionPersistData}
 * @param {ActionInfo} actionInfo 
 * @returns {ActionPersistData<Context>}
 */
export function mapActionInfoToActionPersistData<ElementTypes, Context>(actionInfo: ActionInfo<ElementTypes, Context>): ActionPersistData<Context> {
    const actionPersistData: ActionPersistData<Context> = {
        userSocketUid: actionInfo.userSocketUid,
        notifyRooms: actionInfo.action.params.notifyRooms ?? [],
        logMessage: actionInfo.action.params.logMessage,
        logInfos: actionInfo.action.params.logInfos,
        context: actionInfo.context,
        clientTime: actionInfo.action.clientTime
    };

    const operationList = actionInfo.type === ACTION_TYPE.UNDO ? [...actionInfo.action.operations].reverse() : actionInfo.action.operations;
    const elementsToUpdateByTypeAndId: Record<string, ElementToUpdate> = {};// key = elementTypeName + "@" + elementId (used in opUpdate, opAddToArray, opRemoveFromArray)
    operationList.forEach(op => {
        op.actualize(actionInfo.action);
        op.addServerActionElement(actionPersistData, { elementsToUpdateByTypeAndId, action: actionInfo.action, actionType: actionInfo.type });
    });
    return actionPersistData;
}